<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Статусы заказов</strong>
                </CCardHeader>
                <CCardBody>
                    <StatusDialogTabLinks />
                    <div> 
                        <div class="overflow-hidden border border-gray-300 rounded-md">
                            <div class="flex items-center bg-gray-100 pl-2">
                                <div class="w-2/5 py-2 font-bold">Статус</div>
                                <div class="w-2/5 py-2 font-bold">Доставка<br>(предоплата)</div>
                                <div class="w-2/5 py-2 font-bold">В точке встречи<br>(предоплата)</div>
                                <div class="w-2/5 py-2 font-bold">Самовывоз<br>(предоплата)</div>
                                <div class="w-2/5 py-2 font-bold">Доставка<br>(постоплата)</div>
                                <div class="w-2/5 py-2 font-bold">В точке встречи<br>(постоплата)</div>
                                <div class="w-2/5 py-2 font-bold">Самовывоз<br>(постоплата)</div>
                                <div class="w-1/5 py-2 font-bold">Отслеживается</div>
                            </div>
                            <div>

                                <div
                                    v-for="item in list"
                                    :key="item.label"
                                    class="flex items-center h-10 px-2 py-4 border-t border-gray-300 bg-white"
                                >
                                    <div class="w-2/5">
                                        <span
                                            :class="`text-purple-700 cursor-pointer hover:underline ${item.disabled ? 'disabled' : ''}`"
                                            @click="item.disabled ? () => false : $router.push(item.link)"
                                        >
                                            {{ item.label }}
                                        </span>
                                    </div>

                                    <div class="w-2/5">
                                        {{ labelStatusType(item.prepayment_door) }}
                                    </div>
                                    <div class="w-2/5">
                                        {{ labelStatusType(item.prepayment_meeting_point) }}
                                    </div>
                                    <div class="w-2/5">
                                        {{ labelStatusType(item.prepayment_without) }}
                                    </div>
                                    <div class="w-2/5">
                                        {{ labelStatusType(item.postpaid_door) }}
                                    </div>
                                    <div class="w-2/5">
                                        {{ labelStatusType(item.postpaid_meeting_point) }}
                                    </div>
                                    <div class="w-2/5">
                                        {{ labelStatusType(item.postpaid_without) }}
                                    </div>

                                    <div class="w-1/5">
                                        <CBadge :color="item.enabled ? 'success' : 'secondary'">
                                            {{ item.enabled ? 'Да' : 'Нет' }}
                                        </CBadge>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </CCardBody>
            </CCard>
        </CCol>
        <CModal
            title="Статус"
            :show.sync="visibleModal"
            :footer="false">
            <template>
                <p>Hello world</p>
            </template>
        </CModal>
    </CRow>
</template>

<script>
    import StatusDialogTabLinks from '@/components/entities/EntityStatusDialogsTabLinks'
    import { ORDER_STATUS, STATUS_DIALOGS_TYPES, BUSINESS_TYPE } from '@/utils/order';
    import { orderStatusTitle } from '@/utils/order-views';
    import { cilPencil } from '@coreui/icons';

    export default {
        name: 'StatusDialogStatuses',

        components: {
            StatusDialogTabLinks
        },

        data: () => ({
            list: [],
            visibleModal: false,
            createEditModal: {
                visible: false,
                editMode: false,
                editId: 0,
                status: {
                    title: '',
                    status_type: '',
                    enabled: false,
                }
            }
        }),

        icons: {
            cilPencil
        },

        computed: {
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings')).is_business_admin;
            },
        },

        async mounted() {
            Object.values(ORDER_STATUS).forEach(num => {
                this.list.push({
                    label: orderStatusTitle(num),
                    link: `${this?.$router?.currentRoute?.fullPath}/${num}`,
                    value: num,
                });
            });
            this.list.push({
                label: 'Доставлен до двери',
                link: `${this?.$router?.currentRoute?.fullPath}/25`,
                value: 25,
            })
            await this.fetchStatuses();
        },

        methods: {
            async fetchStatuses() {
                try {
                    const { data = [] } = await this.axios.get(`/status/${BUSINESS_TYPE.ENTITY}`, { params: { id: this.$route.params.id }});
                    const activeStatuses = data?.filter(status => status.enabled);
                    if (activeStatuses?.length) {
                        this.list = this.list.filter(status => ({ ...status }));
                    }

                    this.list = this.list.map(status => {
                        const statusInfo = data?.find(statusInfo => statusInfo.status === status.value);
                        if (statusInfo) {
                            return { ...status, ...statusInfo };
                        }
                        return { ...status };
                    });
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },
            edit(statusId) {
                this.visibleModal = true;
            },
            labelStatusType(statusType) {
                const types = [];
                types.push({ value: STATUS_DIALOGS_TYPES.NOT_PAID_POST, label: 'Заказ принят' });
                types.push({ value: STATUS_DIALOGS_TYPES.NOT_PAID, label: 'Не оплачен' });
                types.push({ value: STATUS_DIALOGS_TYPES.AWAITING, label: 'Собираем' });
                types.push({ value: STATUS_DIALOGS_TYPES.COOKING, label: 'Готовим' });
                types.push({ value: STATUS_DIALOGS_TYPES.IN_WORK, label: 'В работе' });
                types.push({ value: STATUS_DIALOGS_TYPES.DELIVERY, label: 'Консьерж в пути' });
                types.push({ value: STATUS_DIALOGS_TYPES.DONE, label: 'Доставлен' });
                types.push({ value: STATUS_DIALOGS_TYPES.CANCELED, label: 'Отменен' });
                types.push({ value: STATUS_DIALOGS_TYPES.AWAITING_READY, label: 'Готов к выдаче' });
                types.push({ value: STATUS_DIALOGS_TYPES.MEETING_POINT, label: 'В точке встречи' });
                types.push({ value: STATUS_DIALOGS_TYPES.COMPLETED, label: 'Уже у вас' });
                types.push({ value: STATUS_DIALOGS_TYPES.DELIVERED_DOOR, label: 'Доставлен до двери' });

                for (const type of types) {
                    if (type.value === statusType) {
                        return type.label;
                    }
                }
                return '';
            }
        },

    }
</script>
<style scoped>
.disabled {
    color: #8a93a2;
    cursor: default;
}
.disabled:hover {
    text-decoration: none;
}
.danger {
    color: red;
}
</style>
